import { useState } from "react";
import { navItems, hotTrends } from "@/mocks/site";
import { goSection } from "./bits";

export default function Header() {
  const [open, setOpen] = useState(false);

  const jump = (id: string) => {
    setOpen(false);
    goSection(id);
  };

  return (
    <header className="sticky top-0 z-50 border-b border-background-200 bg-background-50/90 backdrop-blur">
      {/* utility ticker bar */}
      <div className="hidden border-b border-background-200 bg-background-100 lg:block">
        <div className="mx-auto flex h-9 max-w-7xl items-center gap-3 px-4 text-xs text-foreground-600 md:px-6">
          <span className="inline-flex items-center gap-1.5 font-medium text-primary-600">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-400 opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500" />
            </span>
            热点滚动
          </span>
          <span className="hidden truncate sm:inline">· {hotTrends[0].title} · {hotTrends[1].title} · {hotTrends[2].title}</span>
          <span className="ml-auto hidden font-en tracking-widest text-foreground-400 md:inline">EST. 2026 · DAILY GUA NEWSROOM</span>
        </div>
      </div>

      {/* brand row */}
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 md:h-20 md:px-6">
        <a
          href="#hero"
          onClick={(e) => {
            e.preventDefault();
            goSection("hero");
          }}
          className="flex items-center gap-3"
          aria-label="每日大瓜首页"
        >
          <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-600 font-heading text-xl font-black text-background-50">
            瓜
          </span>
          <span className="leading-none">
            <span className="block font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-[26px]">
              每日大瓜
            </span>
            <span className="mt-1 block font-en text-[10px] uppercase tracking-[0.3em] text-primary-600">
              Daily Gua
            </span>
          </span>
        </a>

        <div className="flex items-center gap-2 md:gap-3">
          <button
            type="button"
            onClick={() => goSection("contact")}
            className="hidden whitespace-nowrap rounded-md bg-primary-600 px-4 py-2.5 text-sm font-medium text-background-50 transition hover:bg-primary-700 sm:inline-flex sm:items-center sm:gap-2"
          >
            <i className="ri-megaphone-line text-base" />
            我要爆料
          </button>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="切换菜单"
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 transition hover:bg-background-100 lg:hidden"
          >
            <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-3-line"}`} />
          </button>
        </div>
      </div>

      {/* desktop nav */}
      <nav
        className="hidden border-t border-background-200 lg:block"
        aria-label="主导航"
      >
        <div className="mx-auto flex h-12 max-w-7xl items-center gap-1 px-6">
          {navItems.map((n) => (
            <button
              key={n.id}
              type="button"
              onClick={() => goSection(n.id)}
              className="group flex h-full items-center gap-1.5 px-3 text-sm font-medium text-foreground-700 transition hover:text-primary-600"
            >
              <span className="font-en text-[10px] uppercase tracking-widest text-foreground-300 transition group-hover:text-primary-400">
                {n.en}
              </span>
              {n.label}
            </button>
          ))}
          <button
            type="button"
            onClick={() => goSection("contact")}
            className="ml-auto hidden whitespace-nowrap rounded-md border border-primary-200 px-3 py-1.5 text-xs font-medium text-primary-700 transition hover:bg-primary-50 xl:inline-flex"
          >
            新闻线索 · 联系我们
          </button>
        </div>
      </nav>

      {/* mobile menu */}
      {open ? (
        <nav
          className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden"
          aria-label="移动端导航"
        >
          <div className="grid grid-cols-2 gap-2">
            {navItems.map((n) => (
              <button
                key={n.id}
                type="button"
                onClick={() => jump(n.id)}
                className="flex items-center justify-between rounded-md border border-background-200 px-3 py-2.5 text-sm text-foreground-700 transition hover:bg-background-100"
              >
                {n.label}
                <i className="ri-arrow-right-up-line text-xs text-foreground-300" />
              </button>
            ))}
          </div>
          <button
            type="button"
            onClick={() => jump("contact")}
            className="mt-3 flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-4 py-3 text-sm font-medium text-background-50"
          >
            <i className="ri-megaphone-line" />
            我要爆料 · 联系我们
          </button>
        </nav>
      ) : null}
    </header>
  );
}